module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-view-wrapper"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e80c94d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/layout/rtView.vue
// module id = 1396
// module chunks = 116